// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"1ccd6867","572":"910617ce"}[chunkId] + ".chunk.js";
};